
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2866c2c2!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./StationaryAvailability.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./StationaryAvailability.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2866c2c2!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./StationaryAvailability.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProductStationaryAvailability/StationaryAvailability.vue
// module id = 538
// module chunks = 2